import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserDTO } from 'src/app/interfaces/base-entity';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SgsstAuthService {
  private baseUrl = `${environment.host}/api/User`;
    
  constructor(private http: HttpClient) { }

  
  checkUserAuth( userId:string): Observable<UserDTO> {       
      return this.http.get<UserDTO>(`${this.baseUrl}/get`,{ params:{userId}});//, 
    }
}
